module.exports = __webpack_public_path__ + "static/media/listShoulders.a572bdad.png";